import React from 'react';
import { Box } from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import { getMediaPath } from 'app/functions';
import { TextHot } from 'components/common/TextHot';
import { colors, spacing } from 'common/theme';
import ChevronLeftIcon from 'assets/icons/slider-arrow-blue.svg';
import { HOT_YOTER_VIEW_PURCHASED_LABEL } from '../../../../hot_yoter/constants';


export const EligiblesContentColumn = ({
    content,
    hideActionLabel = false,
    typography,
    chevronWidth,
    onActionPress,
    showViewAction = false,
    viewActionExpanded = false,
    onViewActionToggle,
    testID,
}) => (
    <Box
        testId={testID}
        sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            textAlign: 'left',
            minWidth: 0,
            width: '100%',
        }}
    >
        <TextHot
            size="m"
            bold="bold"
            color="primary"
            component="p"
            sx={{
                m: 0,
                width: '100%',
                fontSize: typography.title.fontSize,
                lineHeight: typography.title.lineHeight,
                fontFamily: typography.title.fontFamily,
                textAlign: 'left',
                direction: 'ltr',
            }}
            testID={`${testID}-title`}
        >
            {content.title}
        </TextHot>
        {(content.subtitle || showViewAction) ? (
            <Box
                testId={`${testID}-subtitle-row`}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    columnGap: `${spacing.xs}px`,
                    rowGap: '2px',
                    mt: `${spacing.xs}px`,
                    width: '100%',
                }}
            >
                {content.subtitle ? (
                    <TextHot
                        size="m"
                        color="secondary"
                        component="span"
                        sx={{
                            m: 0,
                            fontSize: typography.title.fontSize,
                            lineHeight: typography.title.lineHeight,
                            textAlign: 'left',
                            direction: 'ltr',
                        }}
                        testID={`${testID}-subtitle`}
                    >
                        {content.subtitle}
                    </TextHot>
                ) : null}
                {showViewAction ? (
                    <Box
                        component="button"
                        type="button"
                        onClick={onViewActionToggle}
                        testId={`${testID}-view-action`}
                        sx={{
                            display: 'inline-flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '2px',
                            p: 0,
                            border: 'none',
                            background: 'transparent',
                            cursor: 'pointer',
                        }}
                    >

                        <TextHot
                            component="span"
                            sx={{
                                m: 0,
                                fontSize: typography.title.fontSize,
                                lineHeight: typography.title.lineHeight,
                                color: colors.system.text.interactive,
                                textDecoration: 'underline',
                                textDecorationColor: colors.system.text.interactive,
                                whiteSpace: 'nowrap',
                            }}
                            testID={`${testID}-view-action-text`}
                        >
                            {HOT_YOTER_VIEW_PURCHASED_LABEL}
                        </TextHot>
                        {viewActionExpanded ? (
                            <KeyboardArrowDownRoundedIcon
                                sx={{
                                    fontSize: typography.title.fontSize,
                                    color: colors.system.text.interactive,
                                }}
                            />
                        ) : (
                            <ChevronLeftRoundedIcon
                                sx={{
                                    fontSize: typography.title.fontSize,
                                    color: colors.system.text.interactive,
                                }}
                            />
                        )}
                    </Box>
                ) : null}
            </Box>
        ) : null}
        {content.actionLabel && !hideActionLabel ? (
            <Box
                component="button"
                type="button"
                onClick={onActionPress}
                testId={`${testID}-action-link`}
                sx={{
                    display: 'inline-flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    alignSelf: 'flex-start',
                    mt: `${spacing.sm}px`,
                    gap: `${spacing.xs}px`,
                    p: 0,
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                }}
            >
                <TextHot
                    size="s"
                    bold="bold"
                    component="span"
                    sx={{
                        fontSize: typography.action.fontSize,
                        lineHeight: typography.action.lineHeight,
                        color: colors.system.brand.accent,
                        textDecoration: 'underline',
                        textAlign: 'right',
                        direction: 'ltr',
                    }}
                    testID={`${testID}-action-text`}
                >
                    {content.actionLabel}
                </TextHot>
                <Box
                    component="img"
                    src={getMediaPath(ChevronLeftIcon)}
                    alt=""
                    testId={`${testID}-action-chevron`}
                    sx={{
                        width: chevronWidth,
                        height: 'auto',
                        mr: `${spacing.lg / 2}px`,
                        flexShrink: 0,
                        filter: 'brightness(0) saturate(100%) invert(27%) sepia(89%) saturate(1500%) hue-rotate(210deg) brightness(95%) contrast(95%)',
                    }}
                />
            </Box>
        ) : null}
    </Box>
);
